import type { ReactElement } from 'react';
import { ColorType } from '@/theme/colors';
import { FontWeight } from '@/theme/typography';
import { Ctext } from '../Ctext';
import {
  CTEXTINPUT_LABEL_FONT_SIZE_PX,
  CTEXTINPUT_TEXT_RESTING_OPACITY,
} from './Ctextinput.constants';

interface CtextinputLabelProps {
  label: string;
}

export function CtextinputLabel({ label }: CtextinputLabelProps): ReactElement {
  return (
    <Ctext
      size={CTEXTINPUT_LABEL_FONT_SIZE_PX}
      weight={FontWeight.Light}
      color={ColorType.White}
      opacity={CTEXTINPUT_TEXT_RESTING_OPACITY}
      align="left"
    >
      {label}
    </Ctext>
  );
}
